{
  "fr": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Modifier les détails",
          "reminder": "Modifier les rappels"
        },
        "closeAllRows": "Fermer toutes les lignes",
        "deleteCount": "Vous êtes sur le point de supprimer {count} tranche. Êtes-vous sûr? | Vous êtes sur le point de supprimer {count} tranches. Êtes-vous sûr?",
        "delete_installments": "Supprimer le tranche | Supprimer les tranches",
        "edit": "Modifier",
        "newInstallment": "Nouvelle tranche de paiement",
        "openAllRows": "Ouvrir toutes les lignes",
        "publish": "Publier",
        "publishCustomer": "Publish...",
        "save": "Mettra à jour",
        "unpublish": "Depublier",
        "updateStatus": "Mettre à jour le statut",
        "uploadInvoice": "Télécharger la facture"
      },
      "attributes": {
        "amount": "Montant",
        "customer": "Client",
        "description": "Description",
        "due_date": "Date limite",
        "group_name": "Tranche de paiement",
        "paid_at": "Payé à",
        "status_deadline": "Statut",
        "unit": "Unité"
      },
      "edit_actions": {
        "edit_amount": "Les montants",
        "edit_deadline": "Date limite",
        "edit_description": "Description",
        "edit_status": "Statut"
      },
      "labels": {
        "cantEditFractions": "Réglez l'état de la tranche de paiement sur 'Brouillon' pour modifier les règles.",
        "changeStatusRequested": "Changer les tranches du statut 'Brouillon' à 'Facturé'",
        "changeVisibility": "Changer la visibilité",
        "change_amounts": "Modifier les montants",
        "clear_due_date": "Supprimer la date d'échéance pour tous les versements sélectionnés",
        "clear_paid_at": "Supprimer la date de paiement pour tous les versements sélectionnés",
        "countEdit": "Modifier la tranche pour 1 unité | Modifier la tranche pour {count} unités",
        "created_at": "Créé {created_at}",
        "deleteExplanation": "Tous les tranches et factures seront définitivement supprimés de la plateforme.",
        "deleteExplanationGroup": "Étant donné que vous souhaitez supprimer tous les tranches de ce groupe, le groupe sera supprimé également.",
        "details": "Détails",
        "edit": "Modifier les tranches de paiement",
        "editDueDate": "Modifier la date limite",
        "editInstallmentTerm": "Modifier tranche de paiement",
        "excl_vat": "hors TVA",
        "giveNewAmount": "Donner un nouveau montant",
        "goToUnitInstallments": "Aller aux tranches de paimenent de l'unité",
        "installmentNoteExplainer": "Cette note n'est visible que par les membres de l'équipe.",
        "installment_categories": "Catégories personnalisées",
        "invoices": "1 facture | {count} factures",
        "new_installment_fraction_category": "Catégorie",
        "noDeadline": "Pas de date limite",
        "notPublished": "Pas publié",
        "paid": "Payé",
        "published": "Publié",
        "publishedCustomer": "Publié pour le client",
        "publishingForCustomers": "Êtes-vous sûr?",
        "selectOne": "Sélectionnez au moins 1 tranche",
        "selected": "{selected} tranche sélectionnée. | {selected} tranches sélectionnés.",
        "setDueDate": "Date limite",
        "statusExplained": "Que signifie l'état de chaque tranche de paiement?",
        "status_click_to_change": "Cliquez pour modifier",
        "status_deadline": "Statut",
        "statuses": {
          "draft": "Brouillon",
          "expected": "Attendu",
          "overdue": "En retard",
          "paid": "Payé",
          "requested": "Facturé"
        },
        "toBePaid": "A payer",
        "total": "Total",
        "unitInstallmentsWillBeShownHere": "Les tranches seront affichés ici",
        "unpublishingForCustomers": "Annulation de la publication des tranches pour toutes les unités. Êtes-vous sûr?",
        "updateStatusCount": "Mettre à jour le statut pour 1 tranche de paiement | Mettre à jour l'état de {count} tranches de paiement",
        "uploadInvoiceCount": "Téléchargez la facture pour 1 tranche de paiement | Télécharger la facture pour {count} versements de paiement",
        "uploadInvoiceUnit": "Téléchargez la facture sur {unit_name}",
        "vat": "TVA",
        "vat_with_percentage": "{percentage}% TVA",
        "view_list": "Liste"
      },
      "legend": {
        "installmentDraft": "Brouillon",
        "installmentDraftAfterDueDate": "Brouillon",
        "installmentExpired": "Délai expiré",
        "installmentPaid": "Tranche déjà payée",
        "installmentPaidAfterDue": "Payé après la date limite",
        "installmentRequested": "Facturé",
        "reminders": {
          "active": "Au moins un rappel a été effectué",
          "none": "Aucun rappel n'a été fixé"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Tous les documents relatifs aux tranches de paiement se trouvent ici.",
            "title": "Aucun document pour le moment!"
          },
          "new": {
            "subtitle": "Des nouvelles tranches viendront bientôt!"
          }
        }
      },
      "sort_options": {
        "due_date": "Date limite",
        "due_date asc": "Délai le plus éloigné en premier",
        "due_date desc": "Délai le plus proche en premier",
        "group_name": "Nom",
        "group_name asc": "Nom A-Z",
        "group_name desc": "Nom Z-A",
        "status": "Statut",
        "status asc": "Statut A-Z",
        "status desc": "Statut Z-A",
        "updated_at asc": "Première mise à jour la plus récente",
        "updated_at desc": "Première mise à jour la plus récente"
      },
      "validation": {
        "needNumber": "Besoin d'un numéro (par exemple 8400.5)"
      }
    }
  }
}
